import { StoryblokComponent } from '@storyblok/react';
import { ChangeEventHandler, useEffect } from 'react';

import { Controller } from 'react-hook-form';

import { patchedStoryblokEditable } from '../../../utils/patchedStoryblokEditable';
import { useFormBuilderContext } from '../hooks/useFormBuilderContext';
import { createRHFControllerValidationRules } from '../utils/validation';
import {
  FormBuilderCheckboxWrapper,
  FormBuilderCheckboxWrapperErrorMessage,
} from './FormBuilderCheckbox.styles';
import { FormBuilderCheckboxProps } from './FormBuilderCheckbox.types';

export const FormBuilderCheckbox = (props: FormBuilderCheckboxProps) => {
  const { blok } = props;
  const { label, key, includeInSubmitRequest, validationRules } = blok;

  const { keyValues, setKeyValue, includeKeyInSubmitRequest, hookForm } = useFormBuilderContext();

  const checked = keyValues[key] === 'true';

  const hookFormErrorMessage = hookForm.formState.errors[key]?.message || null;
  const errorMessage = typeof hookFormErrorMessage === 'string' ? hookFormErrorMessage : null;

  const controllerRules = createRHFControllerValidationRules(validationRules);

  useEffect(() => {
    setKeyValue(key, 'false');

    if (includeInSubmitRequest) {
      includeKeyInSubmitRequest(key);
    }
  }, []);

  const handleCheckboxChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (event.target.checked) {
      setKeyValue(key, 'true');
    } else {
      setKeyValue(key, 'false');
    }
  };

  return (
    <Controller
      name={key}
      control={hookForm.control}
      rules={controllerRules}
      render={({ field }) => (
        <FormBuilderCheckboxWrapper {...patchedStoryblokEditable(blok)}>
          <label>
            <input
              {...field}
              type="checkbox"
              name={key}
              onChange={(event) => {
                field.onChange(event);
                handleCheckboxChange(event);
              }}
              checked={checked}
              className="FormBuilderCheckboxInput"
            />
            {!!label.length && <StoryblokComponent blok={label[0]} />}
          </label>
          {!!errorMessage && (
            <FormBuilderCheckboxWrapperErrorMessage>
              {errorMessage}
            </FormBuilderCheckboxWrapperErrorMessage>
          )}
        </FormBuilderCheckboxWrapper>
      )}
    />
  );
};
